import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';
import { MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CustomValidatorService } from 'src/app/services/custom-validator.service';

@Component({
  selector: 'app-change-password-dialog',
  templateUrl: './change-password-dialog.component.html',
  styleUrls: ['./change-password-dialog.component.css']
})
export class ChangePasswordDialogComponent implements OnInit {
  api_error: any;
  api_success: string;
  account_confirmPassword;
  changePasswordForm: UntypedFormGroup;
  btndisabled  = false;
  formErrors = {
    'oldpassword': '',
    'password': '',
    'confirmPassword': '',

  };
  ValidationMessages = {
    'oldpassword': {
      'required': 'Old password is required',
      'whitespace': 'Invalid old password'
    },
    'password': {
      'required': 'New password is required',
      'whitespace': 'Invalid new password'
    },
    'confirmPassword': {
      'required': 'Re enter the newpassword',
      'whitespace': 'Invalid confirm password'
    }
  };


  constructor(private dialogRef: MatDialogRef<any>, private authService: AuthenticationService,
    private formbuilder: UntypedFormBuilder , private customValidator: CustomValidatorService) {
    this.changePasswordForm = this.formbuilder.group({
      oldpassword: ['', [Validators.required, this.customValidator.noWhiteSpace]],
      password: ['', [Validators.required, this.customValidator.noWhiteSpace]],
      confirmPassword: ['', [Validators.required, this.customValidator.noWhiteSpace]],
    });
  }

  ngOnInit() {
  }
  onchangePassword() {
    if (this.changePasswordForm.invalid) {
      this.api_error = 'Please fill all the required fields of form';
    }else{
    this.api_error = '';
    this.api_success = '';
    if (this.isPasswordMatch()) {
      this.btndisabled = true;
      this.changePasswordForm.removeControl('confirmPassword');
      this.authService.changePassword(this.changePasswordForm.value)
        .subscribe(data => {
          this.btndisabled = false;
          this.api_success = 'Password changed Successfully';
          setTimeout(() => {
            this.dialogRef.close();
          }, 2000);
        },
          (error) => {
            this.btndisabled = false;
            this.api_error = error.error;
          }
        );

    } else {
      this.api_error = 'Passwords Mismatch';
    }
  }

  }
  isPasswordMatch() {
    if (this.changePasswordForm.controls.password.value !== this.changePasswordForm.controls.confirmPassword.value) {
      return false;

    } else {
      return true;
    }

  }
  logValidationErrors(group: UntypedFormGroup = this.changePasswordForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if (abstractControl && !abstractControl.valid &&
        (abstractControl.touched || abstractControl.dirty)) {
        const messages = this.ValidationMessages[key];
        for (const errorKey in abstractControl.errors) {
          if (errorKey) {
            this.formErrors[key] += messages[errorKey] + ' ';
          }
        }
      }

      if (abstractControl instanceof UntypedFormGroup) {
        this.logValidationErrors(abstractControl);
      }
    });


  }
}
